import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
}
export function CTAButton({
  children,
  className = '',
  variant = 'primary'
}: CTAButtonProps) {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg';
  const variants = {
    primary: 'bg-purple-600 hover:bg-purple-700 text-white shadow-purple-500/30',
    secondary: 'bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-white shadow-orange-500/30'
  };
  return <motion.button whileHover={{
    y: -2
  }} whileTap={{
    y: 0
  }} onClick={scrollToPricing} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-273">
      {children}
    </motion.button>;
}
export function SectionHeading({
  children,
  subtitle,
  className = ''
}: {
  children: React.ReactNode;
  subtitle?: string;
  className?: string;
}) {
  return <div className={`text-center mb-12 ${className}`} data-id="element-274">
      <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4" data-id="element-275">
        {children}
      </h2>
      {subtitle && <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-276">{subtitle}</p>}
    </div>;
}
export function PlaceholderImage({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) {
  return <div className={`bg-purple-50 border-2 border-dashed border-purple-200 rounded-2xl flex items-center justify-center text-purple-400 font-medium p-8 text-center ${className}`} data-id="element-277">
      {text}
    </div>;
}